import React from 'react';
import { ContentList } from '../../../../_lib/components/ContentList';
import { PageToPageListItem } from './PageToPageListItem';
import { Assignment } from '../PageToPageAssignmentCard';
import { FooterLink } from '../../../../components/molecules/FooterLink/FooterLink';
import IUrl from '../../../../types/IUrl';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { ContentListModifier } from '../../../../_lib/components/ContentList/ContentList';

export type PageToPageListDefaultViewProps = {
  assignments: Assignment[];
  footerLink?: IUrl;
};

export function PageToPageListDefaultView({ assignments, footerLink }: PageToPageListDefaultViewProps) {
  const { t } = useSonTranslation('PageToPage');

  return assignments && assignments.length > 0 ? (
    <>
      <ContentList modifier={ContentListModifier.BACKGROUND_TRANSPARENT}>
        {assignments.map(assignment => (
          <PageToPageListItem key={assignment.pageLink.url} assignment={assignment} />
        ))}
      </ContentList>
      <FooterLink footerButtonLabel={t('structuralPageToPageFooterLink')} footerLink={footerLink} />
    </>
  ) : null;
}
